import { render } from "./LicenseAssign.vue?vue&type=template&id=38f784a2&scoped=true"
import script from "./LicenseAssign.vue?vue&type=script&lang=js"
export * from "./LicenseAssign.vue?vue&type=script&lang=js"

import "./LicenseAssign.vue?vue&type=style&index=0&id=38f784a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f784a2"]])

export default __exports__